import { useCallback, useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import { getCustomer } from "../Actions/API/Backoffice/BackofficeActions"
import { Customer } from "../Models/API/BackofficeModel"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export const useCustomer = (
    username: string
): [FetchState<Customer>, () => void] => {
    const dispatch = useDispatch()
    const customer = useAppState(state =>
        state.api.backoffice.customers.records.get(username)
    )

    const fetchBackofficeUser = useCallback(
        () => dispatch(getCustomer(username)),
        [dispatch, username]
    )
    useEffect(() => {
        if (customer === undefined) {
            fetchBackofficeUser()
        }
    }, [customer, dispatch, fetchBackofficeUser, username])

    return useMemo(() => {
        return [customer, fetchBackofficeUser]
    }, [customer, fetchBackofficeUser])
}
